export function googleMapsHref(latitude: number, longitude: number): string {
    return `https://www.google.com/maps/place/${latitude},${longitude}`;
}
